import React from 'react';
import { guides, steps } from '../data/kit';
export function Guides() {
  return <section className="bg-sage-50 px-4 py-8 md:py-16" data-id="element-113" data-mp="6lwafaur61mv">
      <div className="max-w-5xl mx-auto" data-id="element-114" data-mp="6mfhtxms17mn">
        <div className="text-center mb-5 md:mb-10" data-id="element-115" data-mp="blim3fuxn9tk">
          <h2 className="font-serif text-[24px] md:text-[42px] font-bold text-wine tracking-tight leading-[1.12] max-w-3xl mx-auto" data-id="element-116" data-mp="bjnytuw6v5mb">
            ASÍ PASA DE “SE TRABA AL LEER”{' '}
            <span className="text-rose-600" data-id="element-117" data-mp="laaa5cwvh9z7">A TENER UN CAMINO CLARO PARA AVANZAR</span>
          </h2>
          <ol className="flex flex-wrap justify-center items-center gap-x-1.5 sm:gap-x-2 gap-y-1 mt-3 md:mt-6 text-[13px] sm:text-sm font-semibold text-rose-700" data-id="element-118" data-mp="pbcaxy6ftu3a">
            {steps.map((step, i) => <li key={step} className="flex items-center gap-1.5 sm:gap-2 whitespace-nowrap" data-id="element-119" data-mp="z9iai94ruo4z" data-mpi={i}>
                {i > 0 && <span className="text-ink-faint" aria-hidden="true" data-id="element-120" data-mp="2w4o934afliik">→</span>}
                <span data-id="element-121" data-mp="3139850dy5w5f">{step}</span>
              </li>)}
          </ol>
        </div>

        <ol className="rounded-3xl bg-white border border-sage-300 divide-y divide-sage-100" data-id="element-122" data-mp="2thkxgzv6rbl9">
          {guides.map((g, i) => <li key={g.title} className="grid grid-cols-[auto_1fr] md:grid-cols-[120px_1fr_1fr] gap-x-4 md:gap-x-5 gap-y-1 md:gap-y-2 px-4 py-4 md:p-7" data-id="element-123" data-mp="2ooi0ehr79k0b" data-mpi={i}>
              <p className="font-serif text-sage-300 font-bold text-3xl md:text-5xl leading-none row-span-2 md:row-span-1" data-id="element-124" data-mp="2fqphl3m9ru86">
                {i + 1}
              </p>
              <div data-id="element-125" data-mp="37g2i2opso7yy">
                <p className="text-[10px] md:text-[11px] font-bold tracking-[0.2em] text-rose-500" data-id="element-126" data-mp="37hlwsavsyaym">
                  MÓDULO {i + 1}
                </p>
                <h3 className="font-serif font-bold text-wine text-base md:text-lg leading-snug mt-0.5 md:mt-1" data-id="element-127" data-mp="2yfw6x9hkjk2y">
                  {g.title}
                </h3>
                <p className="font-bold text-sage-600 text-[15px] md:text-base leading-snug mt-0.5 md:mt-1.5" data-id="element-128" data-mp="1s0val2omszvu">
                  {g.subtitle}
                </p>
              </div>
              <p className="col-start-2 md:col-start-3 text-sm text-ink-muted leading-snug md:leading-relaxed" data-id="element-129" data-mp="1oixrlh6tpqg1">
                {g.desc}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}